import { useEffect, useRef, useState } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getNodesForLessonProgress } from "api/services/node-service";
import { IGetNodeForLessonProgressRequest } from "api/models/request/IGetNodesForLessonProgressRequest";
import { IGetNodesForLessonProgressResponse } from "api/models/response/IGetNodesForLessonProgressResponse";
import { Node } from "models/Node";

export const useGetLessonProgressNodes = (lessonProgressId: string) => {
    const [nodes, setNodes] = useState<Node[]>([]);
    const [feedback, setFeedback] = useState<string | null>(null);
    const { callAPI, loading } = useWorkspaceApiCall<IGetNodeForLessonProgressRequest, IGetNodesForLessonProgressResponse>(getNodesForLessonProgress, undefined, 'getNodesForLessonProgress.error');
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        const fetchNodes = async () => {
            const resp = await callAPI({ lessonProgressId });
            if (resp?.success && resp.data?.nodes) {
                setNodes(resp.data.nodes);
                setFeedback(resp.data.feedback ?? null);
            }
        }

        if (!lessonProgressId) {
            setNodes([]);
            setFeedback(null);
            return;
        }

        if (!hasCalledAPI.current) {
            hasCalledAPI.current = true;
            fetchNodes();
        }
    }, [lessonProgressId, callAPI, loading]);

    return { nodes, feedback, gettingNodes: loading };
}
